import { UserProfileDomain } from 'core/typing/domains/UserProfileDomain/UserProfileDomain';
import { createEvent } from 'effector';

export const loadUserProfile = createEvent('loadUserProfile');
export const loadUserProfileDone = createEvent<UserProfileDomain>('loadUserProfileDone');
export const loadUserProfileFail = createEvent('loadUserProfileFail');
export const updateUserProfile = createEvent<UserProfileDomain>('updateUserProfile');
export const acceptTermsUser = createEvent<boolean>('loadAcceptTerm');
export const loadChangeLanguage = createEvent<string>('loadChangeLanguage');
